import { useEffect } from 'react'

import Apptentive from 'helpers/apptentive'

const useTrackScrollPositionOnPage = (pageName: string, scrollPositions: number[], startTracking = true) => {
  useEffect(() => {
    let handleScroll

    if (startTracking) {
      const loggedPositions = new Set()

      handleScroll = () => {
        const windowHeight = window.innerHeight
        const documentHeight = document.documentElement.scrollHeight
        const scrollTop = window.pageYOffset

        const scrollableHeight = documentHeight - windowHeight
        const percentageScrolled = (scrollTop / scrollableHeight) * 100

        scrollPositions.forEach((position) => {
          if (percentageScrolled >= position && !loggedPositions.has(position)) {
            loggedPositions.add(position)

            Apptentive.sendEvent(`${pageName}_${position}_percent_depth`)
          }
        })
      }

      window.addEventListener('scroll', handleScroll)
    }

    return () => window.removeEventListener('scroll', handleScroll)
  }, [startTracking, pageName]) // eslint-disable-line react-hooks/exhaustive-deps
}

export default useTrackScrollPositionOnPage
